import { useTranslation } from "react-i18next";
export const AssistantData = () => {
  const { t } = useTranslation();
    return [
        {
            imgURL: "/images/members/assistant/team_shihhsun.jpg",
            name: {
                chinese: "范姜士燻",
                english: "Shih-Hsun Fan Chiang"
            },
            email: "squall.f@gmail.com",
            spec: t("page.member.info.assistant.Shih-Hsun.spec"),
        },
        {
            imgURL: "/images/members/assistant/team_yayuanchang.jpg",
            name: {
                chinese: "章雅媛",
                english: "Ya-Yuan Chang"
            },
            email: "yychang@ncu.edu.tw",
            officePhone: "03-422-7151#35235",
            workContent: t("page.member.info.assistant.Ya-Yuan.workContent"),
        }
    ]
}
